<template>
    <div class="articulo body">
        <div id="content">
            <div class="post" v-for="(data, index) in json" :key="index">
                <div class="container" v-if="data.id == $route.params.id">
                    <div class="post-standard">
                        <div class="post-standard__banner">
                            <div class="post-standard__banner__image">
                                <img :src="'../../static/blog/img/'+data.imagen" alt="Post banner image"/>
                            </div>
                            <div class="post-standard__banner__content">
                                <div class="post-card -center">
                                    <div></div>
                                    <div class="card__content">
                                        <h5 class="card__content-category">{{data.categoria}}</h5>
                                        <a class="card__content-title">{{data.titulo}}</a>
                                        <div class="card__content-info">
                                            <div class="info__time">
                                                <p>Publicado en {{data.fecha}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-8 mx-auto">
                                <div class="post-standard__content">
                                    <div id="post-share">
                                        <h5>Compartir:</h5>
                                        <div class="social-media">
                                            <ShareNetwork
                                                network="facebook"
                                                :url="url"
                                                :title="data.titulo"
                                            >
                                                <img src="../../static/blog/img/icn_facebook_black.svg" alt="Facebook">
                                            </ShareNetwork>
                                            <ShareNetwork
                                                network="twitter"
                                                :url="url"
                                                :title="data.titulo"
                                            >
                                                <img src="../../static/blog/img/icn_twitter_black.svg" alt="Twitter">
                                            </ShareNetwork>
                                        </div>
                                    </div>
                                    <div v-html="data.info" class="text"></div>
                                    <div class="post-footer">
                                        <div class="post-footer__related">
                                            <div class="post-footer__related__item -prev">
                                                <div v-for="(info, index) in json" :key="index">
                                                    <div v-if="parseInt(info.id) == parseInt($route.params.id)-1">
                                                        <router-link :to="'/Articulo/'+info.id"> <img class="imgPrev" src="../../static/blog/img/icn_previous.svg" alt="Anterior">Artículo anterior</router-link>
                                                        <div class="post-footer__related__item__content">
                                                            <img :src="'../../static/blog/img/'+info.imagen"/>
                                                            <div class="post-card ">
                                                                <div></div>
                                                                <div class="card__content">
                                                                    <h5 class="card__content-category">{{info.categoria}}</h5>
                                                                    <router-link class="card__content-title" :to="'/Articulo/'+info.id">{{info.titulo}}</router-link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="post-footer__related__item -next">
                                                <div v-for="(info, index) in json" :key="index">
                                                    <div v-if="parseInt(info.id)== parseInt($route.params.id)+1">
                                                        <router-link :to="'/Articulo/'+info.id">Artículo siguiente<img class="imgNext" src="../../static/blog/img/icn_next.svg" alt="Siguiente"></router-link>
                                                        <div class="post-footer__related__item__content">
                                                            <div class="post-card -right">
                                                                <div></div>
                                                                <div class="card__content">
                                                                    <h5 class="card__content-category">{{info.categoria}}</h5>
                                                                    <router-link class="card__content-title" :to="'/Articulo/'+info.id">{{info.titulo}}</router-link>
                                                                </div>
                                                            </div>
                                                            <img :src="'../../static/blog/img/'+info.imagen"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="fb-comments" :data-href="url" data-numposts="" data-width="100%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SliderInstagram/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SliderInstagram from './SliderInstagram'
    import Blog from './blog.json'
    export default {
        components: {
            SliderInstagram
        },
        mounted() {
            for (var i in this.json) {
                if(this.$route.params.id == this.json[i].id){
                    this.titulo = this.json[i].titulo
                    this.imagen = this.json[i].imagen
                    this.resumen = this.json[i].resumen
                }
            }
        },
        metaInfo() {
            return {
                title: this.titulo,
                meta: [
                    { name: 'twitter:card', content: 'summary_large_image' },
                    { property: 'fb:app_id', content: '939899129837142' },
                    { property: 'og:title', content: this.titulo },
                    { property: 'og:site_name', content: this.titulo},
                    { property: 'og:description', content: this.resumen},
                    { property: 'og:type', content: this.resumen},
                    { property: 'og:url', content: this.url },
                    { property: 'og:image', content: this.origin+'/static/blog/img/'+this.imagen }
                ]
            }
        },
        data(){
            return{
                json: Blog.slice().reverse(),
                url: window.location.href,
                titulo: '',
                origin: window.location.origin,
                imagen: '',
                resumen: ''

            }
        }
    }
</script>

<style scoped>
    ol{
      margin-left: 15px;
    }
    .articulo{
        padding: 100px 0;
        background-color: white;
    }
    #content{
        padding: 0;
    }
    .post .post-standard__banner__image{
        z-index: 1;
    }
    .post .post-standard__banner__content{
        z-index: 2;
    }
    .post .post-standard #post-share{
        left: -120px;
    }
    .post-footer{
        margin: 80px 0;
    }
    .post-footer__related{
        margin-bottom: 0;
    }
    .post .post-standard #post-share .social-media a{
        background-color: transparent;
    }
    .social-media img{
        cursor: pointer;
    }
    .imgPrev, .imgNext{
        width: 7px;
        vertical-align: middle;
        /* display: flex; */
        /* align-items: center; */
    }
    .imgPrev{
        margin-right: 5px;
    }
    .imgNext{
        margin-left: 5px;
    }
    .fb-comments{
        margin-top: 80px;
    }

</style>

<style>
    .articulo .text *{
        color: #292929!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Articulo.vue